<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_2"></a><a id="Copyright">Published in 2012 by<br/>
Grub Street<br/>
4 Rainham Close<br/>
London<br/>
SW11 6SS<br/>
Email: </a><a href="mailto:food@grubstreet.co.uk">food@grubstreet.co.uk</a><br/>
Web: <a href="http://www.grubstreet.co.uk" target="_blank">www.grubstreet.co.uk</a><br/>
Twitter @grub_steeet</p>
<p class="copyright3">Text and illustrations copyright © Suzanne Dunaway 1999, 2012<br/>
Copyright this edition © Grub Street 2012<br/>
Book and jacket design Sarah Driver<br/>
First published in the United States by Hyperion</p>
<p class="copyright3">A CIP catalogue record for this book is available from The British Library</p>
<p class="copyright3">ISBN 978-1-908117-21-2<br/>
EPUB ISBN: 978-1-909808-73-7</p>
<p class="copyright3">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any<br/>
means, electronic or mechanical, including photocopying, recording or any information storage and<br/>
retrieval system, without permission in writing from the publisher.</p>
<p class="copyright3">Printed and bound in Slovenia</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?5a0ab471